var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 469.333 469.333",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 85.333,
    cy: 202.667,
    r: 21.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 202.667,
    r: 21.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.667,
    cy: 202.667,
    r: 21.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 309.333,
    cy: 202.667,
    r: 21.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 202.667,
    r: 21.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.333,
    cy: 288,
    r: 21.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 288,
    r: 21.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.667,
    cy: 288,
    r: 21.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.333,
    cy: 373.333,
    r: 21.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 373.333,
    r: 21.333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.667,
    cy: 373.333,
    r: 21.333
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.333,32h-32V21.333c0-5.888-4.768-10.667-10.667-10.667S384,15.445,384,21.333V32h-42.667V21.333 c0-5.888-4.768-10.667-10.667-10.667S320,15.445,320,21.333V32h-42.667V21.333c0-5.888-4.768-10.667-10.667-10.667 S256,15.445,256,21.333V32h-42.667V21.333c0-5.888-4.768-10.667-10.667-10.667S192,15.445,192,21.333V32h-42.667V21.333 c0-5.888-4.768-10.667-10.667-10.667S128,15.445,128,21.333V32H85.333V21.333c0-5.888-4.768-10.667-10.667-10.667 S64,15.445,64,21.333V32H32C14.357,32,0,46.357,0,64v64v298.667c0,17.643,14.357,32,32,32h405.333c17.643,0,32-14.357,32-32V128 V64C469.333,46.357,454.976,32,437.333,32z M448,426.667c0,5.877-4.779,10.667-10.667,10.667H32 c-5.888,0-10.667-4.789-10.667-10.667v-288H448V426.667z M448,117.333H21.333V64c0-5.877,4.779-10.667,10.667-10.667h405.333 C443.221,53.333,448,58.123,448,64V117.333z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M341.333,256c-41.163,0-74.667,33.493-74.667,74.667s33.504,74.667,74.667,74.667S416,371.84,416,330.667 S382.496,256,341.333,256z M341.333,384C311.925,384,288,360.075,288,330.667s23.925-53.333,53.333-53.333 s53.333,23.925,53.333,53.333S370.741,384,341.333,384z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M366.933,317.867h-12.8v-12.8c0-7.072-5.728-12.8-12.8-12.8s-12.8,5.728-12.8,12.8v12.8h-12.8 c-7.072,0-12.8,5.728-12.8,12.8s5.728,12.8,12.8,12.8h12.8v12.8c0,7.072,5.728,12.8,12.8,12.8s12.8-5.728,12.8-12.8v-12.8h12.8 c7.072,0,12.8-5.728,12.8-12.8S374.005,317.867,366.933,317.867z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8b9fb1caf96a16b2565ce5ef589ba1d2.svg";
export { ForwardRef as ReactComponent };